import React, { FC } from 'react';
import { lazyWidget } from 'src/configs/components/lazyWidget';
import McrYanFrame from '../McrYanFrame';

const Calculadoradenatalmetapapi = lazyWidget(
  () => import('src/components/base-components/CustomHtml/Calculadoradenatalmetapapi')
);
const Explicativonatalmetapapi = lazyWidget(
  () => import('src/components/base-components/CustomHtml/Explicativonatalmetapapi')
);

const webSiteUrl = 'https://papigames.bet.br';

const routeMap = {
  '/explicativonatalmetapapi': {
    component: Explicativonatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2683719&utm_source=2683719&utm_medium=2683719&utm_campaign=2683719`,
  },
  '/explicativonatalmetadi': {
    component: Explicativonatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2682407&utm_source=2682407&utm_medium=2682407&utm_campaign=2682407`,
  },
  '/explicativonatalgooglepapi': {
    component: Explicativonatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2705755&utm_source=2705755&utm_medium=2705755&utm_campaign=2705755`,
  },
  '/explicativonatalgoogledi': {
    component: Explicativonatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2682402&utm_source=2682402&utm_medium=2682402&utm_campaign=2682402`,
  },
  '/explicativonataltiktokpapi': {
    component: Explicativonatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2759652&utm_source=2759652&utm_medium=2759652&utm_campaign=2759652`,
  },
  '/explicativonataltiktokdi': {
    component: Explicativonatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2785248&utm_source=2785248&utm_medium=2785248&utm_campaign=2785248`,
  },
  '/calculadoradenatalmetapapi': {
    component: Calculadoradenatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2683719&utm_source=2683719&utm_medium=2683719&utm_campaign=2683719`,
  },
  '/calculadoradenatalmetadi': {
    component: Calculadoradenatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2682407&utm_source=2682407&utm_medium=2682407&utm_campaign=2682407`,
  },
  '/calculadoradenatalgooglepapi': {
    component: Calculadoradenatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2705755&utm_source=2705755&utm_medium=2705755&utm_campaign=2705755`,
  },
  '/calculadoradenatalgoogledi': {
    component: Calculadoradenatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2682402&utm_source=2682402&utm_medium=2682402&utm_campaign=2682402`,
  },
  '/calculadoradenataltiktokpapi': {
    component: Calculadoradenatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2759652&utm_source=2759652&utm_medium=2759652&utm_campaign=2759652`,
  },
  '/calculadoradenataltiktokdi': {
    component: Calculadoradenatalmetapapi,
    btnUrl: `${webSiteUrl}/?affiliateId=2785248&utm_source=2785248&utm_medium=2785248&utm_campaign=2785248`,
  },
  '/mcryan': { component: McrYanFrame },
};

const RedirectToCustomHtmlOrFrame: FC = () => {
  const routeConfig = routeMap[window.location.pathname];
  if (!routeConfig) return null;

  const { component: Component, btnUrl } = routeConfig;
  return <Component btnUrl={btnUrl} />;
};

export default RedirectToCustomHtmlOrFrame;
